import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AttachmentController::upload
* @see app/Http/Controllers/AttachmentController.php:25
* @route '/attachments/upload/{type}/{attachableType}/{attachableId}'
*/
export const upload = (args: { type: string | number, attachableType: string | number, attachableId: string | number } | [type: string | number, attachableType: string | number, attachableId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/attachments/upload/{type}/{attachableType}/{attachableId}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AttachmentController::upload
* @see app/Http/Controllers/AttachmentController.php:25
* @route '/attachments/upload/{type}/{attachableType}/{attachableId}'
*/
upload.url = (args: { type: string | number, attachableType: string | number, attachableId: string | number } | [type: string | number, attachableType: string | number, attachableId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            attachableType: args[1],
            attachableId: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        attachableType: args.attachableType,
        attachableId: args.attachableId,
    }

    return upload.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{attachableType}', parsedArgs.attachableType.toString())
            .replace('{attachableId}', parsedArgs.attachableId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::upload
* @see app/Http/Controllers/AttachmentController.php:25
* @route '/attachments/upload/{type}/{attachableType}/{attachableId}'
*/
upload.post = (args: { type: string | number, attachableType: string | number, attachableId: string | number } | [type: string | number, attachableType: string | number, attachableId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
export const download = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

download.definition = {
    methods: ["get","head"],
    url: '/download/{attachment}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
download.url = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { attachment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            attachment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment: typeof args.attachment === 'object'
        ? args.attachment.id
        : args.attachment,
    }

    return download.definition.url
            .replace('{attachment}', parsedArgs.attachment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
download.get = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: download.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AttachmentController::download
* @see app/Http/Controllers/AttachmentController.php:116
* @route '/download/{attachment}'
*/
download.head = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: download.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
export const bulkDownload = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkDownload.url(args, options),
    method: 'get',
})

bulkDownload.definition = {
    methods: ["get","head"],
    url: '/zip-download/{resourceType}/{resourceId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
bulkDownload.url = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            resourceType: args[0],
            resourceId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        resourceType: args.resourceType,
        resourceId: args.resourceId,
    }

    return bulkDownload.definition.url
            .replace('{resourceType}', parsedArgs.resourceType.toString())
            .replace('{resourceId}', parsedArgs.resourceId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
bulkDownload.get = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bulkDownload.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AttachmentController::bulkDownload
* @see app/Http/Controllers/AttachmentController.php:133
* @route '/zip-download/{resourceType}/{resourceId}'
*/
bulkDownload.head = (args: { resourceType: string | number, resourceId: string | number } | [resourceType: string | number, resourceId: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bulkDownload.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AttachmentController::update
* @see app/Http/Controllers/AttachmentController.php:74
* @route '/attachments/{attachment}'
*/
export const update = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/attachments/{attachment}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\AttachmentController::update
* @see app/Http/Controllers/AttachmentController.php:74
* @route '/attachments/{attachment}'
*/
update.url = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { attachment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            attachment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment: typeof args.attachment === 'object'
        ? args.attachment.id
        : args.attachment,
    }

    return update.definition.url
            .replace('{attachment}', parsedArgs.attachment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::update
* @see app/Http/Controllers/AttachmentController.php:74
* @route '/attachments/{attachment}'
*/
update.patch = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\AttachmentController::destroy
* @see app/Http/Controllers/AttachmentController.php:123
* @route '/attachments/{attachment}'
*/
export const destroy = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/attachments/{attachment}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AttachmentController::destroy
* @see app/Http/Controllers/AttachmentController.php:123
* @route '/attachments/{attachment}'
*/
destroy.url = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { attachment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { attachment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            attachment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        attachment: typeof args.attachment === 'object'
        ? args.attachment.id
        : args.attachment,
    }

    return destroy.definition.url
            .replace('{attachment}', parsedArgs.attachment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AttachmentController::destroy
* @see app/Http/Controllers/AttachmentController.php:123
* @route '/attachments/{attachment}'
*/
destroy.delete = (args: { attachment: string | number | { id: string | number } } | [attachment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const AttachmentController = { upload, download, bulkDownload, update, destroy }

export default AttachmentController